'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Bell, Search, Zap, ChevronDown, Settings, LogOut, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


export default function DashboardTopbar() {
  const [profileOpen, setProfileOpen] = useState(false);

  return (
    <header className="h-16 bg-card border-b border-border flex items-center px-4 lg:px-6 gap-4 flex-shrink-0">
      {/* Search */}
      <div className="flex-1 max-w-md">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search lessons, vocabulary, modules..."
            className="w-full pl-9 pr-4 py-2 rounded-xl text-sm bg-muted border border-transparent focus:border-primary focus:bg-card outline-none transition-all"
          />
        </div>
      </div>
      {/* XP Badge */}
      <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-xl bg-amber-50 border border-amber-200">
        <Zap size={14} className="text-amber-600" />
        <span className="text-xs font-bold text-amber-700 font-tabular">2,840 XP</span>
      </div>
      {/* Notifications */}
      <div className="relative">
        <button className="relative w-9 h-9 rounded-xl hover:bg-muted flex items-center justify-center transition-colors">
          <Bell size={18} className="text-muted-foreground" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-danger" />
        </button>
      </div>
      {/* Profile */}
      <div className="relative">
        <button
          className="flex items-center gap-2.5 hover:bg-muted px-2 py-1.5 rounded-xl transition-colors"
          onClick={() => setProfileOpen(!profileOpen)}
        >
          <div className="w-8 h-8 rounded-full gradient-green flex items-center justify-center text-white text-xs font-bold">
            PR
          </div>
          <div className="hidden sm:flex flex-col text-left">
            <span className="text-xs font-bold text-foreground leading-none">Priya R.</span>
            <span className="text-xs text-primary leading-none font-medium">Active Speaker</span>
          </div>
          <ChevronDown size={14} className="text-muted-foreground hidden sm:block" />
        </button>

        {profileOpen && (
          <div className="absolute right-0 top-full mt-2 w-52 bg-card rounded-2xl border border-border shadow-modal z-50 fade-in overflow-hidden">
            <div className="p-4 border-b border-border">
              <p className="text-sm font-bold text-foreground">Priya Raghunandan</p>
              <p className="text-xs text-muted-foreground">priya.r@gmail.com</p>
              <div className="mt-2 flex items-center gap-2">
                <span className="badge-green text-xs">Active Speaker</span>
                <span className="text-xs text-muted-foreground font-tabular">Level 3</span>
              </div>
            </div>
            <div className="p-2">
              {[
                { icon: User, label: 'My Profile' },
                { icon: Settings, label: 'Settings' },
              ]?.map((item) => {
                const Icon = item?.icon;
                return (
                  <button
                    key={`profile-menu-${item?.label}`}
                    className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
                  >
                    <Icon size={15} />
                    {item?.label}
                  </button>
                );
              })}
              <div className="h-px bg-border mx-1 my-1" />
              <Link
                href="/sign-up-login-screen"
                className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-danger hover:bg-danger/5 transition-all"
              >
                <LogOut size={15} />
                Sign Out
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}